<template>
  <span class="action__cost">
    <!-- A worker glyph at zero when no worker is needed, whatever else it
         costs (Matt, playtest 10: "a zero workers icon... would make it obvious"). -->
    <Pip v-if="!hands" class="pip--zero" :kind="handKind" :n="0" />
    <Pip v-for="p in pips" :key="p.kind" :kind="p.kind" :n="p.n" />
    <span v-if="!pips.length" class="action__free">free</span>
    <slot />
  </span>
</template>

<script>
import Pip from './Pip.vue';
import { SPENDABLE } from './resourceArt';

// What an action takes from you, in the same glyphs a card's cost rail uses.
// Matt: "maybe we can adopt that everywhere else as a standardized set of
// icons and concepts." Every board's action list goes through this.
const ORDER = [...SPENDABLE, 'population', 'happiness'];

export default {
  name: 'ActionCost',
  components: { Pip },
  props: {
    cost: { type: Object, default: () => ({}) },
    // The Stewards spend shifts, not people: same number, its own glyph.
    asShifts: { type: Boolean, default: false },
    // The Frontier spends actions (two a worker, 2026-10-15): its own glyph.
    asActions: { type: Boolean, default: false },
  },
  computed: {
    handKind() { return this.asShifts ? 'shifts' : (this.asActions ? 'actions' : 'workers'); },
    hands() { return ((this.cost || {}).workers || 0) > 0; },
    pips() {
      return ORDER
        .filter((k) => (this.cost || {})[k] > 0)
        .map((k) => ({ kind: k === 'workers' ? this.handKind : k, n: this.cost[k] }));
    },
  },
};
</script>
